__webpack_require__.p = "/mi-assets/mi-static/mi-shop-renderer-2/web-rel-26.6.2-2026-712026/_next/";